import { render, staticRenderFns } from "./academicList.vue?vue&type=template&id=c015406e&scoped=true&"
import script from "./academicList.vue?vue&type=script&lang=js&"
export * from "./academicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c015406e",
  null
  
)

export default component.exports